import { useNavigate } from 'react-router-dom'
import { Lock } from 'lucide-react'

/**
 * Shown when the backend returns 403 MODULE_NOT_ENABLED.
 * Can also be rendered directly in a page component when `useModule(slug)` returns false.
 */
export function ModuleDisabledPage({ message }: { message?: string }) {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4 text-center px-4">
      <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-muted/10 border border-border">
        <Lock className="h-7 w-7 text-muted" />
      </div>
      <div className="space-y-1 max-w-sm">
        <h2 className="text-base font-semibold text-muted-fg">Module not available</h2>
        <p className="text-sm text-muted">
          {message ?? 'This module is not included in your current plan. Please upgrade or contact your administrator to enable it.'}
        </p>
      </div>
      <button
        onClick={() => navigate('/')}
        className="mt-2 rounded-lg border border-border px-4 py-2 text-sm font-medium text-muted hover:bg-surface-overlay transition-colors"
      >
        Go to Dashboard
      </button>
    </div>
  )
}
